interface Class<T> {
  new(...args: any[]): T
}
type Registry = { [s: string]: any }

const WINDOW_REF = 'window'

const registry: Registry = {}

const getKey = (clz: Class<any> | string): string => {
  if (typeof clz === 'string') {
    return clz
  }
  return clz.name
}

const InjectionConfig = {

  bind: <T>(clz: Class<T> | string, impl: T) => {
    registry[getKey(clz)] = impl
  },

  get: <T>(clz: Class<T> | string): T => {
    const obj = registry[getKey(clz)]
    if (obj) {
      return obj
    }
    if (typeof clz !== 'string') {
      return new clz
    }
    return null
  }
}

export {
  InjectionConfig,
  WINDOW_REF
}
